import MainLoader from './MainLoader';
import Main from 'controllers/Main';


export default new class {
	
	constructor() {
		Main.on( Main.E.INIT_STATIC_VIEW, this.init, this );
	}
	
	
	init() {
		MainLoader.init();
	}
	
	
};
